module.exports = __webpack_public_path__ + "img/magento-badge.e8f37281.svg";